import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useTranslation } from 'react-i18next';
import UserService from '../../../../services/UserService/UserService';

/**
 * @Description This function lets you return User Details dialog component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */

function UserDetails({ open, setOpen }) {
    const { t } = useTranslation();
    const label = 'CONTENT.USER.';
    const [user, setUser] = useState({});
    const [tab, setTab] = useState('user');

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        const res = await UserService.getUserByID(open.id);
        if (res.status) { setUser(res.data.data); }
    }

    const handleClose = () => { setOpen({ open: false, id: '' }); };

    const handleClick = (e) => { setTab(e.target.value); }

    return (
        <Dialog className="user-detail-dialog" onClose={handleClose} open={true} maxWidth="lg">
            <div className="db-tabs db-page">
                <button className={tab === 'user' ? 'db-tabactive' : ''} value="user" onClick={handleClick}>
                    {t(label + 'USER-DETAILS')}
                </button>
                <button className={tab === 'bot' ? 'db-tabactive' : ''} value="bot" onClick={handleClick}>
                    {t('CONTENT.BOTS.BOT-DETAILS')}
                </button>
            </div>
            {tab === 'user' ?
                <div className="user-details">
                    <div>
                        <div className="bot-desc-label">{t(label + 'FIRST-NAME')}</div>
                        <div className="bot-desc-info">{user.first_name}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(label + 'LAST-NAME')}</div>
                        <div className="bot-desc-info">{user.last_name}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(label + 'E-MAIL')}</div>
                        <div className="bot-desc-info">{user.user_email}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(label + 'STATUS')}</div>
                        <div className="bot-desc-info">{user.status ? 'Active' : 'Passive'}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(label + 'DOMAIN')}</div>
                        <div className="bot-desc-info">{user.domain}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t('CONTENT.ROLE.ASSIGNED-ROLES')}</div>
                        <div className="bot-desc-info role">{user.roles?.map((item, itemI) => {
                            return <div key={itemI}>{item.role_name}{itemI !== user.roles.length - 1 && <span>,&nbsp;&nbsp;</span>}</div>
                        })}</div>
                    </div>
                </div> :
                <div className="bot-details">
                    <div className="bot-desc-label">No details found.</div>
                </div>
            }
            <div className="user-details-close">
                <button onClick={handleClose}>{t('CONTENT.LIBRARY.BROWSER.ACTION.CLOSE')}</button>
            </div>
        </Dialog>
    );
}
export default UserDetails;
